import { render, staticRenderFns } from "./CustomerCategoryQuantity.vue?vue&type=template&id=6982ae5b&scoped=true"
import script from "./CustomerCategoryQuantity.vue?vue&type=script&lang=js"
export * from "./CustomerCategoryQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6982ae5b",
  null
  
)

export default component.exports